import { ArrowRight } from "lucide-react";
import { Link } from "react-router-dom";
import { SOLUTIONS } from "../../lib/solutionsContent";

export function SolutionsSection() {
  return (
    <section className="landing-solutions" id="soluzioni" data-testid="landing-solutions">
      <div className="landing-section-head landing-reveal">
        <p className="landing-module-num">SOLUZIONI <i /> PER MODULO</p>
        <h2>Approfondisci il modulo che ti serve</h2>
        <p className="landing-desc">Ogni modulo risolve un problema concreto dell'officina: apri la pagina dedicata e vedi cosa fa, come si usa e cosa cambia.</p>
      </div>
      <div className="landing-solution-grid">
        {SOLUTIONS.map((solution, index) => (
          <Link
            className="landing-solution-card landing-reveal"
            style={{ transitionDelay: `${index * 80}ms` }}
            to={solution.path}
            key={solution.slug}
            data-testid={`landing-solution-${solution.slug}`}
          >
            <p className="landing-module-num">{String(index + 1).padStart(2, "0")} <i /> {solution.nav.toUpperCase()}</p>
            <h3>{solution.title}</h3>
            <p>{solution.teaser}</p>
            <span>Scopri il modulo <ArrowRight size={14} /></span>
          </Link>
        ))}
      </div>
    </section>
  );
}
